import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * V196: 전화번호 자동 하이픈 포맷터
 * 입력: 숫자만 추출하여 한국 전화번호 형식으로 포맷
 *
 * 형식:
 * - 휴대폰: 010-1234-5678 (11자리)
 * - 서울: 02-1234-5678 (10자리, 02로 시작)
 * - 지역/대표: 031-123-4567 (10자리) 또는 031-1234-5678 (11자리)
 * - 대표번호: 1588-1234 (8자리, 15/16/18로 시작)
 */
export function formatPhoneNumber(value: string): string {
  // 숫자만 추출
  const numbers = value.replace(/\D/g, '');

  if (!numbers) return '';

  // 대표번호 (1588, 1577, 1644, 1899 등)
  if (/^1[5-9]\d{2}/.test(numbers)) {
    if (numbers.length <= 4) return numbers;
    return `${numbers.slice(0, 4)}-${numbers.slice(4, 8)}`;
  }

  // 서울 (02)
  if (numbers.startsWith('02')) {
    if (numbers.length <= 2) return numbers;
    if (numbers.length <= 5) return `${numbers.slice(0, 2)}-${numbers.slice(2)}`;
    if (numbers.length <= 9) return `${numbers.slice(0, 2)}-${numbers.slice(2, 5)}-${numbers.slice(5)}`;
    return `${numbers.slice(0, 2)}-${numbers.slice(2, 6)}-${numbers.slice(6, 10)}`;
  }

  // 휴대폰 및 일반 지역번호 (3자리 지역번호)
  if (numbers.length <= 3) return numbers;
  if (numbers.length <= 6) return `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
  if (numbers.length <= 10) return `${numbers.slice(0, 3)}-${numbers.slice(3, 6)}-${numbers.slice(6)}`;
  return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7, 11)}`;
}

/**
 * V196: 사업자등록번호 자동 하이픈 포맷터
 * 형식: 000-00-00000 (10자리)
 */
export function formatBusinessNumber(value: string): string {
  // 숫자만 추출
  const numbers = value.replace(/\D/g, '');

  if (!numbers) return '';
  if (numbers.length <= 3) return numbers;
  if (numbers.length <= 5) return `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
  return `${numbers.slice(0, 3)}-${numbers.slice(3, 5)}-${numbers.slice(5, 10)}`;
}
